import BaseService from 'services/BaseService';
import LinkHelper from 'util/LinkHelper';

const linkhelper = new LinkHelper();

class InsightsMonthlyService extends BaseService {
    constructor() {
        let apiName = 'InsightsMonthlyDataAPI';

        let tenantApiName = 'TenantManagementServiceAPI';

        let collectionPath = '/monthly';

        super(apiName, tenantApiName, collectionPath);
    }

    async getTenantId() {
        if (linkhelper.getCurAuthTenandid() !== null) {
            return {
                'pac-selected-tenant-id': linkhelper.getCurAuthTenandid(),
                'pac-selected-tenant-icao': linkhelper.getCurAuthTenantIcao()
            };
        }

        return null;
    }

    async fetchFilterValuesAxios(params, cancelRequestToken) {
        let path = process.env.REACT_APP_INSIGHTS_API_URL + `/v2/metrics/filter_values`;

        let headers;
        let queryStringParameters;

        await this.getTenantId().then((response) => {
            headers = response;
        });

        // path = 'https://fowv27q7vj.execute-api.us-west-2.amazonaws.com/default' + `/v2/metrics/filter_values`;
        // headers['api_name'] = 'filters';

        if (window.sessionStorage.getItem('rack_data_env') === 'Rack') {
            headers['rack_test_api_name'] = 'filters';
        }

        if (window.sessionStorage.getItem('rack_data_env') === 'All') {
            headers['nonlicensed_data'] = true;
        }

        queryStringParameters = params;

        let options = {
            headers: headers,
            cancelToken: cancelRequestToken,
            params: queryStringParameters
        };

        if (options.headers) {
            options.headers.Authorization = await this.getAuthorizationHeader();
        }

        return this.makeGetApiCallAxios(path, options);
    }

    async fetchSubscriptionData() {
        let path = `/v2/info/subscription_info`;

        let headers;
        await this.getTenantId().then((response) => {
            headers = response;
        });

        if (headers && headers['pac-selected-tenant-icao'] === 'all') {
            headers['pac-selected-tenant-icao'] = 'pac';
        }

        if (headers && window.sessionStorage.getItem('rack_data_env') === 'Rack') {
            path = '/v2/metrics/rack_data';
            headers['rack_test_api_name'] = 'subscription_info';
        }

        let options = {
            body: {},
            headers: headers
        };

        return new Promise((resolve, reject) => {
            this.makePostApiCall(this.apiName, path, options).then((response) => {
                if (response) {
                    return resolve(response);
                } else {
                    return reject(response);
                }
            });
        });
    }

    async fetchFlightMetricsAxios(payload, cancelRequestToken, nonlicensedMode = false) {
        let path = `/v2/metrics/flight_metrics_data`;

        let headers;
        if (nonlicensedMode) {
            headers = {
                'pac-selected-tenant-id': 'PAC',
                'pac-selected-tenant-icao': 'PAC'
            };
        } else {
            await this.getTenantId().then((response) => {
                headers = response;
            });
        }

        let options = {
            headers: headers
        };

        return this.postAxios(path, payload, options, cancelRequestToken);
    }

    async fetchMyInsightsTrendsMetricsAxios(payload, path, cancelRequestToken) {
        let headers;
        await this.getTenantId().then((response) => {
            headers = response;
        });

        let options = {
            headers: headers
        };

        return this.postAxios(path, payload, options, cancelRequestToken);
    }

    async fetchNextInsightsMetricsAxios(payload, path, cancelRequestToken) {
        let headers;
        await this.getTenantId().then((response) => {
            headers = response;
        });

        let options = {
            headers: headers
        };

        if (path === '/v2/metrics/screen_transition_data') {
            payload.response_filename =
                'screen_transitions_' + headers['pac-selected-tenant-icao'] + '_' + Date.now() + '.json';
        }

        return this.postAxios(path, payload, options, cancelRequestToken);
    }

    async fetchEngagementMetricsAxios(payload, cancelRequestToken) {
        let path = `/v2/metrics/engagement_data`;

        let headers;
        await this.getTenantId().then((response) => {
            headers = response;
        });

        let options = {
            headers: headers
        };

        //return {"airline_code":"SIA","requested_sections":{"passenger_engagement":{"total_time":{"data":[{"label":"Movies","value":"76.1","comparison_value":"-2.8","comparison_raw_value":"78.3","nominal_value":"98989876","comparison_nominal_value":"54545454"},{"label":"TV Series","value":"13.8","comparison_value":"-6.1","comparison_raw_value":"14.7","nominal_value":"899999","comparison_nominal_value":"565656565656"},{"label":"Audio","value":"8.3","comparison_value":"62.7","comparison_raw_value":"5.1","nominal_value":"799999","comparison_nominal_value":"23423432"},{"label":"Games","value":"1.2","comparison_value":"-40","comparison_raw_value":"2","nominal_value":"699999","comparison_nominal_value":"676767676"},{"label":"Trailer","value":"0.3","comparison_value":"100","comparison_raw_value":"0","nominal_value":"599999","comparison_nominal_value":"676"},{"label":"Live TV","value":"0.2","comparison_value":"100","comparison_raw_value":null,"nominal_value":"499999","comparison_nominal_value":"67676"},{"label":"Others","value":"0","comparison_value":"0","comparison_raw_value":null,"nominal_value":"399999","comparison_nominal_value":"23"},{"label":"Video","value":"0","comparison_value":"0","comparison_raw_value":null,"nominal_value":"299999","comparison_nominal_value":"656565"}]},"total_views":{"data":[{"label":"Audio","value":"43","comparison_value":"51.4","comparison_raw_value":"28.4","nominal_value":"6768954","comparison_nominal_value":"999998"},{"label":"Movies","value":"32.9","comparison_value":"-33.1","comparison_raw_value":"49.2","nominal_value":"1234","comparison_nominal_value":"999998"},{"label":"TV Series","value":"13.9","comparison_value":"-35.3","comparison_raw_value":"21.5","nominal_value":"2345","comparison_nominal_value":"999998"},{"label":"Others","value":"5.1","comparison_value":"100","comparison_raw_value":null,"nominal_value":"3456","comparison_nominal_value":"999998"},{"label":"Trailer","value":"3.6","comparison_value":"1700","comparison_raw_value":"0.2","nominal_value":"4567","comparison_nominal_value":"999998"},{"label":"Games","value":"1.2","comparison_value":"71.4","comparison_raw_value":"0.7","nominal_value":"5678","comparison_nominal_value":"999998"},{"label":"Live TV","value":"0.3","comparison_value":"100","comparison_raw_value":null,"nominal_value":"6789","comparison_nominal_value":"999998"},{"label":"Video","value":"0","comparison_value":"0","comparison_raw_value":null,"nominal_value":"7891","comparison_nominal_value":"999998"}]}},"ped_vs_seatback":{"total_time":{"data":[{"label":"PED","value":"44","comparison_value":"-45.9","comparison_raw_value":"81.5","nominal_value":"12345","comparison_nominal_value":"234334343343"},{"label":"Seatback","value":"56","comparison_value":"201.7","comparison_raw_value":"18.5","nominal_value":"8765456","comparison_nominal_value":"3434343"}]},"total_views":{"data":[{"label":"PED","value":"20.9","comparison_value":"-64.8","comparison_raw_value":"59.2","nominal_value":"567895","comparison_nominal_value":"1234567"},{"label":"Seatback","value":"79.1","comparison_value":"94","comparison_raw_value":"40.8","nominal_value":"4598765","comparison_nominal_value":"345678"}]}},"portal_device_browser":{"total_counts":{"data":[{"label":"Mobile Safari","value":"66","comparison_value":1,"comparison_raw_value":null},{"label":"Chrome Mobile WebView","value":"10.5","comparison_value":-22,"comparison_raw_value":null},{"label":"Chrome Mobile","value":"8.7","comparison_value":33,"comparison_raw_value":null},{"label":"Chrome Mobile iOS","value":"3.8","comparison_value":44,"comparison_raw_value":null},{"label":"Safari","value":"3.1","comparison_value":null,"comparison_raw_value":null},{"label":"Chrome","value":"2.3","comparison_value":null,"comparison_raw_value":null},{"label":"Samsung Internet","value":"1.3","comparison_value":null,"comparison_raw_value":null},{"label":"Others","value":"4.6","comparison_value":null,"comparison_raw_value":null}]}},"portal_device_os":{"total_counts":{"data":[{"label":"iOS","value":"70.3","comparison_value":0,"comparison_raw_value":null},{"label":"Android","value":"24.3","comparison_value":-10,"comparison_raw_value":null},{"label":"Mac OS X","value":"3.3","comparison_value":12,"comparison_raw_value":null},{"label":"Windows","value":"1","comparison_value":null,"comparison_raw_value":null},{"label":"Others","value":"1","comparison_value":null,"comparison_raw_value":null},{"label":"Linux","value":"0","comparison_value":null,"comparison_raw_value":null}]}}}};
        return this.postAxios(path, payload, options, cancelRequestToken);
    }

    async fetchFlightsAxios(payload, cancelRequestToken) {
        let path = `/v2/metrics/flight_list_data`;

        let headers;
        await this.getTenantId().then((response) => {
            headers = response;
        });

        let options = {
            headers: headers,
            cancelToken: cancelRequestToken
        };

        if (options.headers) {
            options.headers.Authorization = await this.getAuthorizationHeader();
        }

        //path = process.env.REACT_APP_INSIGHTS_API_URL + path;

        return this.postAxios(path, payload, options);
    }

    async fetchLopa(payload) {
        let path = `/v2/metrics/seat_usage_data`;

        let headers;
        let options = {
            body: payload,
            headers: headers
        };

        await this.getTenantId().then((response) => {
            headers = response;
        });

        options = { headers: headers, body: payload };

        return this.postAxios(path, payload, options, null);
    }

    async fetchFeatureFlags() {
        let path = process.env.REACT_APP_INSIGHTS_API_URL + `/v2/info/feature_flags`;

        let headers;
        try {
            headers = {
                'pac-selected-tenant-icao': 'pac',
                Authorization: await this.getAuthorizationHeader()
            };
        } catch (error) {
            console.log(error);
            return;
        }

        let options = {
            body: {},
            headers: headers
        };

        return new Promise((resolve, reject) => {
            this.makeGetApiCallAxios(path, options).then((response) => {
                if (response) {
                    return resolve(response);
                } else {
                    return reject(response);
                }
            });
        });
    }

    async fetchWorkbenchData(payload, cancelRequestToken) {
        let path = `/v2/metrics/workbench_metrics_data`;

        let headers;
        await this.getTenantId().then((response) => {
            headers = response;
        });

        let options = { headers: headers, body: payload, cancelToken: cancelRequestToken };

        return this.postAxios(path, payload, options);
    }
}

export default InsightsMonthlyService;
